import React from 'react';
import Pinpoints from '../components/Pinpoints';

export default function OfficeCleaning() {
  return (
    <main className='am-container office-cleaning-page'>
      <section className='oc-hero'>
        <div className='oc-content'>
          <h1 className='oc-title'>A Clean Office for a More Productive Workplace</h1>

          <p className='oc-lead'>
            A spotless, well-maintained office is essential for productivity and employee well-being.
          </p>

          <p className='oc-lead'>
            At AM Facilities, we provide professional office cleaning services tailored to your business needs—ensuring
            a clean, healthy, and welcoming workspace every day.
          </p>

          <h2 className='oc-sub'>Our Office Cleaning Services Include:</h2>

          <Pinpoints
            className='oc-list'
            iconClass='oc-badge'
            itemTag='div'
            items={[
              <>
                <strong>Desk & Surface Cleaning:</strong> Eliminating dust, germs, and clutter.
              </>,
              <>
                <strong>Floor Care:</strong> Vacuuming, mopping, and carpet maintenance for pristine floors.
              </>,
              <>
                <strong>Restroom Sanitization:</strong> Deep cleaning and disinfecting for hygiene and safety.
              </>,
              <>
                <strong>Breakroom & Kitchen Cleaning:</strong> Keeping shared spaces spotless and sanitary.
              </>,
              <>
                <strong>Trash Removal:</strong> Regular waste disposal for a tidy environment.
              </>,
            ]}
          />

          <p className='oc-cta-lead'>
            Enhance your office environment with our expert cleaning services. Contact us now for a customized cleaning
            plan!
          </p>

          <div className='oc-actions'>
            <a
              className='am-cta am-cta-primary'
              href='https://app.zenmaid.com/book/a-m-facilities'
              target='_blank'
              rel='noreferrer noopener'
            >
              Get a Free Quote Today!
            </a>
          </div>

          <div className='oc-back'>
            <a href='/#services' className='oc-back-link'>
              ← Back to Services
            </a>
          </div>
        </div>

        <aside className='oc-aside'>
          <img src='/assets/office_cleaning.avif' alt='Office cleaning' />
        </aside>
      </section>
    </main>
  );
}
